import React from "react";
import { FaEnvelope, FaWhatsapp } from "react-icons/fa";
import "./DeliveryMethodSelector.css";

export default function DeliveryMethodSelector({
  methods,
  onChange,
  className = "",
}) {
  const toggle = (key) => {
    const next = { ...methods, [key]: !methods[key] };
    if (!next.email && !next.whatsapp) return;
    onChange(next);
  };

  return (
    <div className={`delivery-method-selector ${className}`}>
      <span className="delivery-method-label">Send this message via</span>
      <div className="delivery-method-options">
        <button
          type="button"
          className={`delivery-method-pill ${methods.email ? "active" : ""}`}
          onClick={() => toggle("email")}
          aria-pressed={methods.email}
        >
          <FaEnvelope /> Email
        </button>
        <button
          type="button"
          className={`delivery-method-pill ${methods.whatsapp ? "active" : ""}`}
          onClick={() => toggle("whatsapp")}
          aria-pressed={methods.whatsapp}
        >
          <FaWhatsapp /> WhatsApp
        </button>
      </div>
      {methods.whatsapp && (
        <p className="delivery-method-hint">
          WhatsApp will open with your message pre-filled — just hit send to
          deliver it.
        </p>
      )}
    </div>
  );
}
